<template>
  <div class="user-list-container">
    <!-- 搜索区域 -->
    <div class="search-section">
      <el-form :inline="true" :model="searchForm" class="search-form">
        <el-form-item label="邮箱">
          <el-input v-model="searchForm.email" placeholder="请输入邮箱" clearable></el-input>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="searchForm.role" placeholder="请选择角色" clearable>
            <el-option label="工作人员" value="1"></el-option>
            <el-option label="管理员" value="2"></el-option>
            <el-option label="超级管理员" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="searchForm.status" placeholder="请选择状态" clearable>
            <el-option label="待审核" value="0"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核未通过" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="resetSearch">重置</el-button>
        </el-form-item>
      </el-form>
    </div>

    <!-- 表格区域 -->
    <div class="table-section">
      <el-table v-loading="loading" :data="userList" border :row-class-name="tableRowClassName" style="width: 100%"
        :header-cell-style="{ backgroundColor: '#f5f5f5', fontWeight: 'bold' }">
        <el-table-column prop="email" label="邮箱">
        </el-table-column>
        <el-table-column prop="name" label="姓名" width="100">
        </el-table-column>
        <el-table-column prop="role" label="角色" width="120">
          <template slot-scope="scope">
            <el-tag :type="getRoleTagType(scope.row.role)" size="medium">
              {{ getRoleText(scope.row.role) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="注册时间" width="180">
        </el-table-column>
        <el-table-column prop="status" label="状态" width="120">
          <template slot-scope="scope">
            <el-tag :type="getStatusTagType(scope.row.status)" size="medium">
              {{ getStatusText(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- 只有超级管理员可以编辑 -->
            <el-button v-if="isSuperAdmin()" size="mini" type="text" @click="handleEdit(scope.row)">编辑</el-button>

            <!-- 待审核状态显示通过/拒绝按钮 -->
            <template v-if="scope.row.status === '0'">
              <el-button size="mini" type="success" plain @click="handleApprove(scope.row)">通过审核</el-button>
              <el-button size="mini" type="danger" plain @click="handleReject(scope.row)">拒绝审核</el-button>
            </template>

            <!-- 审核通过状态显示拒绝按钮 -->
            <template v-else-if="scope.row.status === '1'">
              <el-button size="mini" type="warning" plain @click="handleReject(scope.row)">拒绝通过</el-button>
            </template>

            <!-- 审核未通过状态显示通过按钮 -->
            <template v-else-if="scope.row.status === '2'">
              <el-button size="mini" type="success" plain @click="handleApprove(scope.row)">通过审核</el-button>
            </template>

            <template v-if="scope.row.status !== '0' && isSuperAdmin()">
              <el-button size="mini" type="text" @click="handleResetPassword(scope.row)">重置密码</el-button>
            </template>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页区域 -->
    <div class="pagination-section">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="pagination.page" :page-sizes="[10, 20, 50, 100]" :page-size="pagination.size"
        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
      </el-pagination>
    </div>

    <!-- 用户编辑表单对话框 -->
    <el-dialog title="编辑用户" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
      <el-form :model="userForm" :rules="userRules" ref="userForm" label-width="80px" status-icon>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="userForm.email" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="userForm.name" placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="role">
          <el-select v-model="userForm.role" placeholder="请选择角色" style="width: 100%;">
            <el-option label="工作人员" value="1"></el-option>
            <el-option label="管理员" value="2"></el-option>
            <el-option label="超级管理员" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态" prop="status">
          <el-select v-model="userForm.status" placeholder="请选择状态" style="width: 100%;">
            <el-option label="待审核" value="0"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="审核未通过" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 角色选择对话框 -->
    <el-dialog title="选择用户角色" :visible.sync="roleDialogVisible" width="400px" :close-on-click-modal="false">
      <el-form :model="roleForm" label-width="100px">
        <el-form-item label="选择角色">
          <el-radio-group v-model="roleForm.selectedRole">
            <el-radio label="1">工作人员</el-radio>
            <el-radio label="2">管理员</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="roleDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmApprove" :loading="submitLoading">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getUserList, updateUserStatus, resetUserPassword, isSuperAdmin, isAdmin } from '@/utils/auth';
import { MessageBox } from 'element-ui';

export default {
  name: 'UserList',
  data() {
    return {
      // 搜索表单
      searchForm: {
        email: '',
        role: '',
        status: ''
      },
      // 用户列表
      userList: [],
      // 加载状态
      loading: false,
      // 分页参数
      pagination: {
        page: 1,
        size: 10,
        total: 0
      },
      // 对话框相关
      dialogVisible: false,
      submitLoading: false,
      // 用户表单
      userForm: {
        email: '',
        name: '',
        role: '1',   // 默认工作人员
        status: '0'  // 默认待审核
      },
      // 表单验证规则
      userRules: {
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: ['blur', 'change'] }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
        ],
        role: [
          { required: true, message: '请选择角色', trigger: 'change' }
        ],
        status: [
          { required: true, message: '请选择状态', trigger: 'change' }
        ]
      },
      // 角色选择对话框相关
      roleDialogVisible: false,
      roleForm: {
        selectedRole: '1'
      }
    };
  },
  created() {
    // 检查是否为管理员或超级管理员
    if (!isAdmin()) {
      this.$router.replace('/');
      this.$message.error('无权访问此页面');
      return;
    }
    this.fetchUserList();
  },
  methods: {
    // 获取用户列表
    fetchUserList() {
      this.loading = true;
      const params = {
        page: this.pagination.page,
        size: this.pagination.size,
        ...this.searchForm
      };

      getUserList(params)
        .then(response => {
          this.loading = false;

          if (response && response.code === 200) {
            // 处理返回的列表数据
            this.userList = (response.data.list || []).map(user => {
              // 确保role和status是字符串类型
              return {
                ...user,
                role: user.role ? String(user.role) : '1',
                status: user.status ? String(user.status) : '0'
              };
            });
            this.pagination.total = response.data.total || 0;
          } else {
            this.$message.error(response.message || '获取用户列表失败');
          }
        })
        .catch(error => {
          this.loading = false;
          console.error('获取用户列表失败:', error);
          this.$message.error('网络异常，请稍后重试');
        });
    },

    // 搜索
    handleSearch() {
      this.pagination.page = 1;
      this.fetchUserList();
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        email: '',
        role: '',
        status: ''
      };
      this.handleSearch();
    },

    // 分页大小变化
    handleSizeChange(size) {
      this.pagination.size = size;
      this.fetchUserList();
    },

    // 页码变化
    handleCurrentChange(page) {
      this.pagination.page = page;
      this.fetchUserList();
    },

    // 编辑用户
    handleEdit(row) {
      this.userForm = { ...row };
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.userForm && this.$refs.userForm.clearValidate();
      });
    },

    // 判断当前用户是否是超级管理员
    isSuperAdmin() {
      return isSuperAdmin();
    },

    // 通过审核
    handleApprove(row) {
      // 保存当前操作的用户
      this.userForm = { ...row };

      // 如果当前登录用户是超级管理员，显示角色选择对话框
      if (this.isSuperAdmin()) {
        this.roleForm.selectedRole = row.role || '1'; // 默认保持原角色
        this.roleDialogVisible = true;
      } else {
        // 普通用户直接确认操作
        this.$confirm(`确定要通过用户 ${row.name} 的审核吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.directApprove();
        }).catch(() => { });
      }
    },

    // 直接审核通过（非超级管理员使用）
    directApprove() {
      this.submitLoading = true;

      // 调用更新用户状态API，设置为审核通过，保持原角色
      updateUserStatus({
        userId: this.userForm.id,
        status: '1',  // 审核通过
        role: this.userForm.role
      }).then(response => {
        this.submitLoading = false;

        if (response && response.code === 200) {
          this.$message.success('审核通过成功');
          this.fetchUserList(); // 刷新列表
        } else {
          this.$message.error(response.message || '操作失败');
        }
      }).catch(error => {
        this.submitLoading = false;
        console.error('操作失败:', error);
        this.$message.error('网络异常，请稍后重试');
      });
    },

    handleResetPassword(row) {
      this.submitLoading = true;
      MessageBox.confirm(`确定重置当前用户密码为[123456]`, '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        resetUserPassword({
          userId: row.id,
        }).then(response => {
          this.submitLoading = false;

          if (response && response.code === 200) {
            this.$message.success('重置密码成功');
          } else {
            this.$message.error(response.message || '操作失败');
          }
        }).catch(error => {
          this.submitLoading = false;
          console.error('操作失败:', error);
          this.$message.error('网络异常，请稍后重试');
        });
      })
    },

    // 确认角色选择并审核通过（超级管理员使用）
    confirmApprove() {
      this.submitLoading = true;

      // 调用更新用户状态API，设置为审核通过，使用选择的角色
      updateUserStatus({
        userId: this.userForm.id,
        status: '1',  // 审核通过
        role: this.roleForm.selectedRole
      }).then(response => {
        this.submitLoading = false;

        if (response && response.code === 200) {
          this.roleDialogVisible = false;
          this.$message.success('审核通过成功');
          this.fetchUserList(); // 刷新列表
        } else {
          this.$message.error(response.message || '操作失败');
        }
      }).catch(error => {
        this.submitLoading = false;
        console.error('操作失败:', error);
        this.$message.error('网络异常，请稍后重试');
      });
    },

    // 拒绝审核
    handleReject(row) {
      this.$confirm(`确定要拒绝用户 ${row.name} 的审核吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用更新用户状态API，设置为审核未通过
        updateUserStatus({
          userId: row.id,
          status: '2',  // 审核未通过
          role: row.role
        }).then(response => {
          if (response && response.code === 200) {
            this.$message.success('已拒绝审核');
            this.fetchUserList(); // 刷新列表
          } else {
            this.$message.error(response.message || '操作失败');
          }
        }).catch(error => {
          console.error('操作失败:', error);
          this.$message.error('网络异常，请稍后重试');
        });
      }).catch(() => { });
    },

    // 提交表单
    submitForm() {
      this.$refs.userForm.validate(valid => {
        if (valid) {
          this.submitLoading = true;

          // 使用updateUserStatus API更新用户信息
          updateUserStatus({
            userId: this.userForm.id,
            status: this.userForm.status,
            role: this.userForm.role
          })
            .then(response => {
              this.submitLoading = false;

              if (response && response.code === 200) {
                this.dialogVisible = false;
                this.$message.success('修改成功');
                this.fetchUserList(); // 刷新列表
              } else {
                this.$message.error(response.message || '修改失败');
              }
            })
            .catch(error => {
              this.submitLoading = false;
              console.error('修改失败:', error);
              this.$message.error('网络异常，请稍后重试');
            });
        } else {
          return false;
        }
      });
    },

    getRoleTagType(role) {
      // 根据角色返回相应的标签类型
      switch (role) {
        case '1':
          return 'info';
        case '2':
          return 'success';
        case '3':
          return 'warning';
        default:
          return '';
      }
    },

    getRoleText(role) {
      // 根据角色返回相应的文本
      switch (role) {
        case '1':
          return '普通用户';
        case '2':
          return '管理员';
        case '3':
          return '超级管理员';
        default:
          return '未知角色';
      }
    },

    getStatusTagType(status) {
      // 根据状态返回相应的标签类型
      switch (status) {
        case '0':
          return 'info';
        case '1':
          return 'success';
        case '2':
          return 'danger';
        default:
          return '';
      }
    },

    getStatusText(status) {
      // 根据状态返回相应的文本
      switch (status) {
        case '0':
          return '待审核';
        case '1':
          return '审核通过';
        case '2':
          return '审核未通过';
        default:
          return '未知状态';
      }
    },

    // 设置表格行样式
    tableRowClassName({ row }) {
      if (row.status === '2') {
        // 审核未通过
        return 'warning-row';
      } else if (row.status === '0') {
        // 待审核
        return 'info-row';
      }
      return '';
    }
  }
};
</script>

<style scoped>
.user-list-container {
  padding: 20px;
  background: #fff;
  border-radius: 4px;
  min-height: calc(100vh - 40px);
}

.search-section {
  margin-bottom: 20px;
  background: #fff;
  padding: 18px;
  border-radius: 4px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.search-form .el-form-item {
  margin-bottom: 0;
}

.table-section {
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08);
}

.pagination-section {
  margin-top: 20px;
  text-align: right;
}

.el-tag {
  padding: 0 10px;
  height: 28px;
  line-height: 26px;
  font-size: 12px;
}

/* 表格行样式 */
::v-deep .warning-row {
  background-color: #fcf8e3;
}

::v-deep .info-row {
  background-color: #f5f5f5;
}

::v-deep .warning-row:hover>td {
  background-color: #f8f0d9 !important;
}

::v-deep .info-row:hover>td {
  background-color: #ececec !important;
}
</style>